<mat-paginator *ngIf="showPaginatorOnTop" [length]="totalTaskItemsCount" [pageSize]="DEFAULT_PAGE_SIZE"
    [pageSizeOptions]="DEFAULT_PAGE_SIZE_OPTIONS" (page)="onPageChanged($event)" aria-label="Select page"
    [showFirstLastButtons]="true">
</mat-paginator>

<div class="task-items-list-container">
    <div *ngIf="isLoading" class="loading-spinner">
        <app-spinner></app-spinner>
    </div>

    <app-process-task-items-list *ngIf="!isLoading" [taskItems]="taskItems">
    </app-process-task-items-list>
</div>

<mat-paginator *ngIf="!showPaginatorOnTop" [length]="totalTaskItemsCount" [pageSize]="DEFAULT_PAGE_SIZE"
    [pageSizeOptions]="DEFAULT_PAGE_SIZE_OPTIONS" (page)="onPageChanged($event)" aria-label="Select page"
    [showFirstLastButtons]="true">
</mat-paginator>
